<script>
  import Crossword from "./Game.svelte";
  import Router from "svelte-spa-router";
  import LandingScreen from "./screens/LandingScreen.svelte";
  import Game from "./screens/GameScreen.svelte";
  import NotFound from "./screens/NotFoundScreen.svelte";
  import PageLayout from "./PageLayout.svelte";

  const routes = {
    "/": LandingScreen,
    "/game/:id": Game,
    "*": NotFound,
  };

  export let id;
</script>

<main>
  <PageLayout>
    <Router {routes} />
  </PageLayout>
</main>

<!--<style global lang="postcss">
  /* only apply purgecss on utilities, per Tailwind docs */
  /* purgecss start ignore */
  @tailwind base;
  @tailwind components;
  /* purgecss end ignore */
  @tailwind utilities;
</style>-->
